import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { EmployeeRelatedList, EmployeeRelatedListRecord } from './types';
import CardHeader from '../CardHeader';
import { FieldValue } from './FieldValue';
import { DropdownActions } from '../../../../atomic/templates/DropdownActions';
import { DropdownActionItem } from '../../../../atomic/molecules/DropdownActionItem';
import FlairIcon from '../../../../atomic/atoms/FlairIcon';

type Props = {
  relatedList: EmployeeRelatedList;
  editable?: boolean;
  onEditRecord?: (record: EmployeeRelatedListRecord) => void;
};

export const RelatedList: React.FC<Props> = ({
  relatedList,
  editable = false,
  onEditRecord,
}) => {
  const { t } = useTranslation();
  const sampleRecord = relatedList.records[0];

  const showActions = editable && !!onEditRecord;

  return (
    <Card>
      <CardHeader>{relatedList.label}</CardHeader>
      {sampleRecord ? (
        <Table size="sm" className="card-table" responsive>
          <thead>
            <tr>
              {sampleRecord.fields.map((field) => (
                <th key={field.fieldInfo.label}>{field.fieldInfo.label}</th>
              ))}
              {showActions && <th aria-label={t('personalData.actions')} />}
            </tr>
          </thead>
          <tbody>
            {relatedList.records.map((record) => (
              <tr key={record.id}>
                {record.fields.map((field, i) => (
                  <td key={`${record.id}-${field.fieldInfo.label}-${i}`}>
                    <FieldValue
                      value={field.value}
                      type={field.fieldInfo.type}
                      options={field.fieldInfo.options}
                    />
                  </td>
                ))}
                {showActions && (
                  <td className="text-end" style={{ width: '1%' }}>
                    <DropdownActions
                      id={`related-list-actions-${record.id}`}
                      icon={<FlairIcon icon="three-dots" />}
                      dataTestId={`related-list-row-actions-${record.id}`}>
                      <DropdownActionItem
                        onClick={() => onEditRecord?.(record)}>
                        {t('personalData.editButton')}
                      </DropdownActionItem>
                    </DropdownActions>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Card.Body className="text-center">
          <span>{t('general.emptyState.table')}</span>
        </Card.Body>
      )}
    </Card>
  );
};
